import React, { ComponentProps } from 'react';
import { SettingsSection } from '../../pgProviderRoute/common/SettingsSection';

/**
 * 결제 설정 화면의 섹션 상자를 그대로 쓰되, 본문을 여백 칸(`settings-section-body` · 24px)으로 감싼다.
 * 공용 SettingsSection 은 본문 여백을 쓰는 쪽이 감싸게 되어 있어서, 빠뜨리면 내용이 테두리에 붙는다.
 */
export const DictSection = (props: ComponentProps<typeof SettingsSection>): React.JSX.Element => {
  const { children, ...rest } = props;
  return (
    <SettingsSection {...rest}>
      <div className="settings-section-body">{children}</div>
    </SettingsSection>
  );
};
